<template>
  <div>
    <div class="d-flex align-center justify-space-between flex-wrap ga-3 mb-4">
      <v-tabs v-model="activeTab" align-tabs="start" color="primary">
        <v-tab
          v-for="tab in availableTabs"
          :key="tab.value"
          :class="{ 'cursor-not-allowed': tab.disabled }"
          :disabled="tab.disabled"
          :value="tab.value">
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <v-btn
        v-if="canEdit"
        :loading="$loading.isLoading('userSendToErm')"
        :readonly="!!user.ermId"
        color="white"
        elevation="1"
        rounded="lg"
        style="border: 1px solid #e4e4e7"
        variant="flat"
        @click="sendToErm">
        <v-icon v-if="!!user.ermId" class="mr-1"> mdi-link </v-icon>
        {{ !!user.ermId ? 'Звязано з ЕРМ' : 'Відправити в ERM' }}
      </v-btn>
    </div>

    <b-section-loader :loading="$loading.isLoading('userSingle')">
      <div>
        <v-window v-model="activeTab">
          <v-window-item value="general">
            <UserCardGeneral />
          </v-window-item>

          <v-window-item v-if="showHistoryTab" value="history">
            <UserCardHistory />
          </v-window-item>

          <v-window-item value="vacations">
            <UserCardVacations />
          </v-window-item>

          <v-window-item value="permissions">
            <UserCardPermissions />
          </v-window-item>

          <v-window-item value="notifications">
            <UserCardNotifications />
          </v-window-item>
        </v-window>
        <UserCardFooter @close="dialog.close()" />
      </div>
    </b-section-loader>
  </div>
</template>

<script>
import { initUserCardStore } from '@/dialog/components/user-card/store'
import { BSectionLoader } from 'best-modules/components'
import UserCardFooter from '@/dialog/components/user-card/UserCardFooter.vue'
import UserCardGeneral from '@/dialog/components/user-card/tabs/general/General.vue'
import UserCardHistory from '@/dialog/components/user-card/tabs/history/History.vue'
import UserCardNotifications from '@/dialog/components/user-card/tabs/notifications/Notifications.vue'
import UserCardPermissions from '@/dialog/components/user-card/tabs/permissions/Permissions.vue'
import UserCardVacations from '@/dialog/components/user-card/tabs/vacations/Vacations.vue'

export default {
  name: 'UserCard',
  components: {
    BSectionLoader,
    UserCardFooter,
    UserCardGeneral,
    UserCardHistory,
    UserCardNotifications,
    UserCardPermissions,
    UserCardVacations,
  },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    return initUserCardStore(props.dialog)
  },
}
</script>
